<template>
  <div class="tabs">
    <div :class="wrapperClass">
      <ul class="nav nav-pills menu-edit" id="pills-tab" role="tablist">
        <li class="nav-item menu-edit" v-for="(tab, index) in tabs" :key="index">
          <a
            class="nav-link menu-edit btn"
            :class="{ active: tab.tabIndex === activeTabIndex, disabled: tab.disabled }"
            id="edit"
            aria-controls="edit"
            :style="!tab.disabled ? 'cursor:pointer;' : 'cursor:not-allowed;'"
            @click="$emit('selectTab', tab.tabIndex)"
          >
            <i v-if="tab.icon?.length > 0" class="fa-solid pr-3" :class="tab.icon"></i>
            <span class="pl-2">
              {{ tab.title }}
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export interface TabTitle {
  title: string
  tabIndex: number
  disabled: boolean
  icon: string
}

export default defineComponent({
  name: 'NavTabs',
  props: {
    tabs: {
      type: Array as PropType<TabTitle[]>
    },
    activeTabIndex: {
      type: Number
    },
    align: {
      type: String
    },
    card: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: [Array, Object, String]
    },
    fill: {
      type: Boolean,
      default: false
    },
    justified: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    navClass: {
      type: [Array, Object, String]
    },
    navWrapperClass: {
      type: [Array, Object, String]
    },
    noFade: {
      type: Boolean,
      default: false
    },
    pills: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selectTab'],
  data() {
    return {
      additionalTabsStart: [
        // Additional tabs before content tabs
      ],
      additionalTabsEnd: [
        // Additional tabs after content tabs
      ]
    }
  },
  computed: {
    wrapperClass() {
      let cssClass = 'nav'

      if (this.fill) {
        cssClass += ' nav-fill'
      }
      if (this.pills) {
        cssClass += ' nav-pills'
      } else {
        cssClass += ' nav-tabs'
      }

      return cssClass
    }
  }
})
</script>
